// authService.ts
import axios from "axios";

const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const EXPIRES_ON_KEY = "expires_on";
const REFRESH_EXPIRES_IN_KEY = "refresh_token_expires_in";

export const authService = {
  saveAuth(data: any) {
    localStorage.setItem(ACCESS_TOKEN_KEY, data.access_token);
    localStorage.setItem(REFRESH_TOKEN_KEY, data.refresh_token);
    localStorage.setItem(EXPIRES_ON_KEY, data.expires_on.toString());
    localStorage.setItem(REFRESH_EXPIRES_IN_KEY, data.refresh_token_expires_in.toString());
  },

  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  getExpiresOn(): number {
    return parseInt(localStorage.getItem(EXPIRES_ON_KEY) ?? "0", 10);
  },

  clearAuth() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(EXPIRES_ON_KEY);
    localStorage.removeItem(REFRESH_EXPIRES_IN_KEY);
  },

  isTokenExpired(): boolean {
    const now = Math.floor(Date.now() / 1000); // seconds
    const expiresOn = this.getExpiresOn();
    return !expiresOn || now >= expiresOn;
  },

  async refreshToken(): Promise<string | null> {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) return null;

    try {
      const body = new URLSearchParams({
        grant_type: "refresh_token",
        refresh_token: refreshToken,
        client_id: process.env.REACT_APP_B2C_CLIENT_ID ?? "",
        scope: `openid offline_access ${process.env.REACT_APP_B2C_SCOPE ?? ""}`,
      });

      const res = await axios.post(
        "https://salemappb2c.b2clogin.com/salemappb2c.onmicrosoft.com/B2C_1_Earfit_Dev/oauth2/v2.0/token",
        body,
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );

      this.saveAuth(res.data);
      return res.data.access_token;
    } catch (err) {
      console.error("Refresh token failed", err);
      this.clearAuth();
      return null;
    }
  },

  async getValidAccessToken(): Promise<string | null> {
    if (!this.isTokenExpired()) {
      return this.getAccessToken();
    }

    // token hết hạn -> thử refresh
    const newToken = await this.refreshToken();
    if (newToken) return newToken;

    // refresh fail -> logout
    this.clearAuth();
    return null;
  },
};
